import React from "react";
import PropTypes from "prop-types";
import "./DocumentView.css";

const ReadOnlyField = ({ label, value, className = "" }) => (
  <div className={`form-row ${className}`.trim()}>
    <span className="form-label">{label}</span>
    <div className="form-value">{value ?? ""}</div>
  </div>
);

ReadOnlyField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

ReadOnlyField.defaultProps = {
  value: "",
  className: "",
};

export default ReadOnlyField;
